import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-one-square",
  "use": "icon-one-square-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-one-square\"><path d=\"M.675 2.951a2.668 2.668 0 0 1 2.66-2.66h10.68c1.47 0 2.66 1.203 2.66 2.66v10.68c0 1.47-1.202 2.66-2.66 2.66H3.335a2.668 2.668 0 0 1-2.66-2.66V2.951zm7.747 10.174h1.56v-9.44H8.555l-2.426 1.8.72 1.24 1.573-1.187v7.587z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol